export const TYPE_CHECKBOXES = 'checkboxes';
export const TYPE_SELECT = 'select';
export const TYPE_RANGE = 'range';
export const TYPE_RANGE_SELECT = 'range_select';
export const TYPE_STRING = 'string';
export const TYPE_TEXTAREA = 'textarea';

export const RANGE_START_APPEND = '__gte';
export const RANGE_END_APPEND = '__lte';
